module.exports = __webpack_public_path__ + "img/icon_weiyitong.4c170945.png";